module.exports = __webpack_public_path__ + "img/base_nature_eau.64f8c2c6.svg";